const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16
  }),
  aggregatedInfo: theme.typography.button,
  groupedInfo: {
    maxWidth: "initial !important",
    width: "100% !important",
    padding: "0px !important"
  },
  groupedInfoHidden: {
    display: "none !important",
    padding: "0px !important"
  },
  aggregatedHidden: {
    flex: "1 !important",
    padding: "0px !important",
    maxWidth: "0px",
    borderRight: "0px !important"
  },
  aggregatedHide: {
    height: "0px"
  },
  table: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    "& .rt-table": {
      marginBottom: "35px"
    },
    "& .rt-td": {
      borderRight: "none!important",
      lineHeight: "50px",
      height: "auto",
      fontSize: "1rem",
      textAlign: "center",
      padding: 0,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "& a": {
        lineHeight: "50px",
        color: theme.palette.primary.main,
        fontWeight: 500,
        fontSize: "1rem",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      "& p": {
        borderRight: "none!important",
        lineHeight: "50px",
        fontSize: "1rem",
        textAlign: "center",
        padding: 0,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
    "& button": {
      backgroundColor: theme.palette.accent,
      color: "white"
    },
    "& .rt-th": {
      border: "none!important"
    },
    "& .rt-tbody": {
      borderTop: "1px solid #E0E0E0 !important",
      padding: "20px 0"
    },
    "& .rt-thead": {
      boxShadow: "none!important",
      border: "none!important"
    },
    "& .rt-tr-group": {
      borderBottom: "1px solid #E0E0E0 !important"
    },
    "& .-pagination": {
      border: "none",
      boxShadow: "none",
      marginBottom: 10,
      "& button": {
        backgroundColor: "#FF7043!important",
        color: "white!important"
      },
      "& .-center": {
        flex: "4 1"
      },
      position: "fixed",
      bottom: "0px",
      backgroundColor: "white",
      marginBottom: "1px",
      "@media screen and (min-width: 1800px)": {
        width: "66%"
      },
      "@media screen and (min-width: 2000px)": {
        width: "58%"
      },
      "@media screen and (min-width: 2200px)": {
        width: "54%"
      },
      "@media screen and (min-width: 2500px)": {
        width: "43%"
      },
      "@media screen and (min-width: 3000px)": {
        width: "40%"
      },
      "@media screen and (min-width: 3500px)": {
        width: "33%"
      },
      "@media screen and (max-width: 1800px)": {
        width: "75%"
      },
      "@media screen and (max-width: 1600px)": {
        width: "83%"
      },
      "@media screen and (max-width: 1450px)": {
        width: "95%"
      },
      "@media screen and (max-width: 680px)": {
        width: "90%"
      }
    },
    "& .-filters input": {
      border: "none!important",
      borderBottom: "2px solid #025794!important",
      borderRadius: "0!important",
      paddingTop: "0!important"
    },
    "& .rt-resizable-header-content": {
      fontSize: "0.9rem",
      fontWeight: 600,
      "& span": {
        height: "auto",
        width: "auto"
      }
    },
    "& .rt-noData": {
      fontSize: "1rem!important",
      padding: "10px",
      color: "#FF7043!important",
      top: "45%!important",
      marginTop: 90
    }
  },
  managedViewportScroll: {
    "& .rt-table": {
      flex: "1 1 auto",
      minHeight: 0,
      minWidth: 0,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      marginBottom: 0
    },
    "& .rt-thead-viewport, & .rt-tfoot-viewport": {
      flex: "0 0 auto",
      minWidth: 0,
      width: "100%",
      overflow: "hidden"
    },
    "& .rt-tbody-viewport": {
      flex: "1 1 auto",
      minHeight: 0,
      minWidth: 0,
      width: "100%",
      overflow: "auto"
    },
    "& .rt-thead, & .rt-tbody, & .rt-tfoot": {
      flex: "0 0 auto",
      overflow: "visible"
    }
  },
  wrapHeaders: {
    "& .rt-thead .rt-tr": {
      minHeight: 46
    },
    "& .rt-th": {
      whiteSpace: "normal"
    },
    "& .rt-resizable-header-content": {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      lineHeight: 1.15,
      minHeight: 36,
      overflow: "visible",
      textOverflow: "clip",
      whiteSpace: "normal"
    }
  },
  saveTarget: {
    opacity: 0.91,
    "&:hover": {
      backgroundColor: "#fd5622!important",
      opacity: '1!important',
    }
  }
});

export default styles;
